module.exports = __webpack_public_path__ + "static/media/Maf_02Julio.da2b83a8.jpg";